export default "__VITE_ASSET__UCthka3S__"